import React from 'react';
import { DimensionTableContainer } from './styled';
import DimensionTableWidget from './dimension-table';
import DimensionHeader from './header';

function DimensionTable({ show, config, widgetIndex }) {
  const { dimensions, unit } = config;

  return (
    <div style={{ display: show ? 'block' : 'none' }}>
      <DimensionHeader widgetIndex={widgetIndex} unit={unit} />
      <DimensionTableContainer id="dimension-table">
        {
          dimensions.map((dimension, dimensionIndex) => (
            <DimensionTableWidget
              key={dimension}
              dimension={dimension}
              widgetIndex={widgetIndex}
              dimensionIndex={dimensionIndex}
              unit={unit}
            />
          ))
        }
      </DimensionTableContainer>
    </div>
  );
}

export default DimensionTable;
